export default __webpack_public_path__ + "static/media/step4.71cbc75b.webp";